<template>
  <BasePage title="Forgot Password">
    <section class="d-flex justify-content-center align-items-center">
      <div>
        <h1 class="fs-10">Authenticating with Social Account...</h1>
        <slot>
          <p class="fs-8 text-muted">this may take a few moments </p>
        </slot>
      </div>
    </section>
  </BasePage>
</template>

<script>
import BasePage from './BasePage'
import store from '../store'
import { socialLogin, socialSignup, invalidOAuthState, socialConnect } from '../actionTypes'

export default {
  name: 'OauthCallback',
  props: {
    provider: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    state: {
      type: String,
      required: true,
    },
    type: {
      // OPTIONS: login, signup, connect
      type: String,
      required: true,
    },
  },
  components: {
    BasePage,
  },
  mounted () {
    const badState = this.state.split('_')[0] !== localStorage.state
    const redirectPath = this.state.split('_')[1]
    if (badState) { return store.dispatch(invalidOAuthState, { route: redirectPath }) }

    const data = {
      provider: this.provider,
      code: this.code
    }

    switch (this.type) {
    case 'login':
      store.dispatch(socialLogin, data)
      break
    case 'connect':
      store.dispatch(socialConnect, data)
      break
    case 'signup':
    default:
      store.dispatch(socialSignup, data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// OAuthLoginCallback.vue?276d58ce